export const BASE_URL = "https://www.indianarmour.com/indianarmourcms";
export const API_URL = "https://www.indianarmour.com/indianarmourcms";
export const WEB_MAIN_URL = "https://www.indianarmour.com/";